// @flow
import React from 'react';
import Box from 'components/Box';
import { FilestackImage } from 'components/Image';
import { TrackedConditionalLink } from 'components/TrackedLink';
import { H2, Body, BodySmall } from 'components/Text';
import type { ImageBlockData } from 'api/cms';

const AmpImageBlock = ({
  data: { headline, subtitle, image, url },
  blockIndex,
  pageUpdated
}: {
  data: ImageBlockData,
  blockIndex: number,
  pageUpdated: string
}) => {
  const { caption, altText } = image;
  return (
    <Box as="figure" m={0} w={1}>
      {(headline || subtitle) && (
        <Box as="figcaption" mb={48}>
          {headline && <H2>{headline}</H2>}
          {subtitle && <Body dangerouslySetInnerHTML={{ __html: subtitle }} />}
        </Box>
      )}
      <Box as={headline || subtitle ? 'figure' : 'div'} m={0}>
        <TrackedConditionalLink
          link={url}
          eventName="CMS Block"
          eventProperties={{
            block_position: blockIndex,
            block_type: 'Image',
            cta_type: 'Image',
            page_updated: pageUpdated
          }}
        >
          <FilestackImage
            data={image}
            alt={altText || ''}
            ampLeftPosition="0"
            ampTopPosition="50%"
            ampHeight={450}
            layout="fill"
          />
        </TrackedConditionalLink>
        {caption && (
          <BodySmall mt="8px" as="figcaption">
            {caption}
          </BodySmall>
        )}
      </Box>
    </Box>
  );
};

export default AmpImageBlock;
